import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SCIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SC" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#FFD018"
          fillRule="evenodd"
          d="M0 11.998 8.076-1h8.075L0 11.998Z"
          clipRule="evenodd"
        />
        <Path fill="#E31D1C" d="M0 11.998 17.232 5.5v-8.05L0 11.998Z" />
        <Path fill="#F7FCFF" d="M0 11.998 17.232 9.5v-4.05L0 11.998Z" />
        <Path
          fill="#5EAA22"
          fillRule="evenodd"
          d="M0 11.998h17.232v-3.55L0 11.998Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
